module.exports = __webpack_public_path__ + "img/receipt.91db2da3.svg";